// extracted by mini-css-extract-plugin
export default {"container":"whatYouWillLearn_container__cphHz","checkMark":"whatYouWillLearn_checkMark__MMkzd","learnings":"whatYouWillLearn_learnings__gbTg9"};